var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeepClean2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8363_3326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13.5833C7.66667 13.5833 9.16667 12.0583 9.16667 10.2083C9.16667 9.24163 8.69167 8.32496 7.74167 7.54996C6.79167 6.77496 6.075 5.62496 5.83333 4.41663C5.59167 5.62496 4.88333 6.78329 3.925 7.54996C2.96667 8.31663 2.5 9.24996 2.5 10.2083C2.5 12.0583 4 13.5833 5.83333 13.5833Z",
    stroke: "#0092B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4669 5.50006C11.04 4.58433 11.4463 3.57426 11.6669 2.51672C12.0835 4.60006 13.3335 6.60006 15.0002 7.93339C16.6669 9.26672 17.5002 10.8501 17.5002 12.5167C17.505 13.6686 17.1676 14.796 16.5309 15.756C15.8941 16.7159 14.9867 17.4652 13.9236 17.9088C12.8606 18.3524 11.6897 18.4704 10.5595 18.2478C9.4293 18.0252 8.39064 17.472 7.5752 16.6584",
    stroke: "#0092B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8363_3326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepClean2Icon);
export default __webpack_public_path__ + "static/media/keep_clean_2_icon.b04b9580965e5f041fcaf313201edc4a.svg";
export { ForwardRef as ReactComponent };